export const vi = {
  app: {
    title: "Báo cáo công việc hàng ngày",
    subtitle: "Nhập trên điện thoại, quản lý tự động",
  },
  common: {
    save: "Lưu",
    cancel: "Hủy",
    edit: "Sửa",
    delete: "Xóa",
    add: "Thêm",
    manage: "Quản lý",
    status: "Trạng thái",
    active: "Hoạt động",
    confirmDelete: "Bạn có chắc muốn xóa?",
    empty: "Không có dữ liệu",
    comingSoon: "Sắp ra mắt",
    logout: "Đăng xuất",
  },
  login: {
    title: "Báo cáo công việc",
    subtitle: "Đăng nhập để tiếp tục",
    username: "Tên đăng nhập",
    password: "Mật khẩu",
    submit: "Đăng nhập",
    submitting: "Đang đăng nhập…",
    invalid: "Tên đăng nhập hoặc mật khẩu không đúng",
    errorGeneric: "Đã xảy ra lỗi khi đăng nhập",
    demoTitle: "Tài khoản dùng thử",
    demoHint: "Nhấn để tự điền",
    demoRoleAdmin: "Quản trị viên",
    demoRoleOperator: "Công nhân tại xưởng",
  },
  home: {
    greeting: "Xin chào, {{name}}",
    subtitle: "Bắt đầu công việc hôm nay",
    action: {
      newReport: "Báo cáo mới",
      list: "Xem báo cáo",
      admin: "Quản trị",
    },
  },
  admin: {
    tab: {
      dashboard: "Tổng quan",
      equipment: "Thiết bị",
      processes: "Công đoạn",
      specs: "Quy cách",
      tools: "Dụng cụ",
      categories: "Danh mục",
      users: "Người dùng",
    },
    equipment: {
      title: "Thiết bị",
      equipmentNo: "Mã thiết bị",
      name: "Tên",
      machineType: "Loại máy",
      add: "Thêm thiết bị",
      edit: "Sửa thiết bị",
      qr: "Mã QR",
      qrPrint: "In",
      qrHint: "Quét để bắt đầu báo cáo",
    },
    process: {
      title: "Công đoạn",
      allEquipment: "Tất cả thiết bị",
      equipment: "Thiết bị",
      processName: "Công đoạn",
      carModel: "Loại xe",
      partNo: "Mã sản phẩm",
      partName: "Tên sản phẩm",
      add: "Thêm công đoạn",
      edit: "Sửa công đoạn",
    },
    spec: {
      title: "Quy cách kiểm tra",
      allProcess: "Chọn công đoạn",
      kind: "Loại",
      specText: "Quy cách",
      period: "Chu kỳ",
      nominal: "Tiêu chuẩn",
      add: "Thêm quy cách",
      edit: "Sửa quy cách",
    },
    tool: {
      title: "Dụng cụ",
      toolSpec: "Quy cách dụng cụ",
      lifetime: "Tuổi thọ",
      add: "Thêm dụng cụ",
      edit: "Sửa dụng cụ",
    },
    category: {
      title: "Danh mục",
      downtime: "Lý do dừng máy",
      defect: "Loại lỗi",
      name: "Tên",
      add: "Thêm danh mục",
      edit: "Sửa danh mục",
    },
    user: {
      title: "Người dùng",
      username: "Tên đăng nhập",
      name: "Họ tên",
      role: "Quyền",
      lang: "Ngôn ngữ",
      password: "Mật khẩu",
      passwordReset: "Đặt lại mật khẩu (tùy chọn)",
      usernameRule: "4–20 ký tự, bắt đầu bằng chữ thường, rồi chữ/số",
      add: "Thêm người dùng",
      edit: "Sửa người dùng",
      roleValue: {
        admin: "Quản trị",
        manager: "Quản lý",
        operator: "Công nhân",
      },
    },
  },
  reports: {
    save: "Lưu",
    saved: "Đã lưu",
    saveError: "Lưu thất bại",
    new: {
      title: "Báo cáo mới",
      equipment: "Thiết bị",
      equipmentPick: "Chọn thiết bị",
      date: "Ngày làm việc",
      start: "Bắt đầu",
    },
    list: {
      title: "Danh sách báo cáo",
      date: "Ngày",
      equipment: "Thiết bị",
      allEquipment: "Tất cả thiết bị",
      from: "Từ",
      to: "Đến",
      producedDay: "Ca ngày (làm/mục tiêu)",
      producedNight: "Ca đêm (làm/mục tiêu)",
      download: "Tải Excel",
    },
    tab: {
      header: "Thông tin",
      inspect: "Kiểm tra",
      defect: "Lỗi",
      downtime: "Dừng máy",
      tools: "Dụng cụ",
      log: "Bất thường",
      photos: "Ảnh",
    },
    photos: {
      add: "Thêm ảnh",
      caption: "Mô tả (tùy chọn)",
      saveFirst: "Lưu báo cáo trước khi đính kèm ảnh.",
    },
    field: {
      process: "Công đoạn",
      targetDay: "Mục tiêu ngày",
      targetNight: "Mục tiêu đêm",
      producedDay: "SL ngày",
      producedNight: "SL đêm",
      heatNo: "HEAT No.",
      defectKind: "Loại lỗi",
      downtimeKind: "Lý do dừng máy",
    },
    toolMark: {
      clear: "Xóa",
    },
    log: {
      anomalies: "Bất thường",
      issues: "Sự việc / Xử lý",
      occurTime: "Thời điểm xảy ra",
      deviation: "Nội dung bất thường",
      afterToolChange: "Sau khi đổi dụng cụ",
      note: "Ghi chú",
      occurrence: "Sự việc",
      action: "Cách xử lý",
    },
    slot: {
      dayStart: "N-Đ",
      dayMid: "N-G",
      dayEnd: "N-C",
      nightStart: "Đ-Đ",
      nightMid: "Đ-G",
      nightEnd: "Đ-C",
    },
    kind: {
      appearance: "Ngoại quan",
      dimension: "Kích thước",
    },
    shift: {
      day: "Ca ngày",
      night: "Ca đêm",
    },
    note: {
      minutes: "Đơn vị: phút",
    },
  },
  dashboard: {
    range: {
      today: "Hôm nay",
      week: "7 ngày gần đây",
      month: "30 ngày gần đây",
    },
    stat: {
      reports: "Số báo cáo",
      achievement: "Tỷ lệ đạt",
      defectRate: "Tỷ lệ lỗi",
      downtime: "Dừng máy",
    },
    outOfSpec: {
      title: "Vượt quy cách: {{count}} mục",
      spec: "Quy cách",
      slot: "Thời điểm",
      value: "Giá trị",
    },
    panel: {
      byDate: "Theo ngày",
      byDowntime: "Lý do dừng máy (phút)",
      byDefect: "Lý do lỗi (cái)",
    },
  },
  health: {
    status: "Trạng thái API",
    checking: "đang kiểm tra…",
  },
} as const;
